// ProtectedRoute.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { NovaPageLoader } from './components/ui/NovaLoader';

const adminOnlyRoutes = [
  '/utilisateurs',
  '/ressources',
  '/listedeclarations',
  '/facturepage',
];

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <NovaPageLoader
        label="Vérification de votre accès"
        helper="Nous sécurisons votre session avant d’ouvrir la page."
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const currentRole = (role || '').toUpperCase();
  const currentPath = decodeURIComponent(location.pathname).toLowerCase();

  const isAdminOnlyRoute = adminOnlyRoutes.some(
    (route) => currentPath === route || currentPath.startsWith(route + '/')
  );

  if (isAdminOnlyRoute && currentRole !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
